import { defineStore } from 'pinia';
import { getCurrentUser } from '@/api/admin';
export const useAdminStore = defineStore('admin', {
    state: () => ({
        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        active: null,
        type: null,
        token: null,
    }),
    actions: {
        async loadUserFromToken() {
            const token = localStorage.getItem('auth_token')
            if (!token) return false;

            try {
                this.token = token

                const { data } = await getCurrentUser();

                this.phone = data.user.phone
                this.email = data.user.email
                this.active = data.user.active
                this.type = data.user.type

                if (this.active === 0) {
                    localStorage.removeItem('auth_token')
                    this.token = null
                    this.clearAdmin()
                    return false;
                }

            } catch (error) {
                console.error('Failed to load user from token:', error)
                localStorage.removeItem('auth_token')
                this.token = null

                return false;
            }



            return true;
        },
        setAdmin(data) {

            this.phone = data.user.phone;
            this.active = data.user.active
            this.type = data.user.type;
            this.email = data.user.email;
            this.token = data.token;
            localStorage.setItem('auth_token', data.token);

        }
        , clearAdmin() {
            this.lastName = '';
            this.firstName = '';
            this.email = '';
            this.phone = '';
            this.active = null;
            this.type = null;
            this.token = null;
            localStorage.removeItem('auth_token');
        }

    },

});
